<script>
import {mapGetters, mapState} from "vuex";
import Tile from '@/components/tile.vue';
import planCommon from './mixin';
import { BILLING_CYCLE, BUNDLE_WITH_ZP_BASE_PLAN_TYPES, planTypes } from '@/common/constants';
import base from '@/views/config/addon-cards/templates/base.vue';
import store from '@/store';
import logo from '@/assets/plans/zoom_phone_additional.svg';
import { additionalConfigType, AdditionalConfigTypeEnums } from './helper';

export default {
  name: 'ZoomPhoneAdditionalNumber',
  mixins: [base, planCommon],
  components: {
    Tile,
  },
  for:() => {
    const hasZoomPhoneWinBack = store.getters.pastPlans.some(plan => [...BUNDLE_WITH_ZP_BASE_PLAN_TYPES, planTypes.ZOOM_PHONE].includes(planTypes[plan.semanticType]));
    if (hasZoomPhoneWinBack) {
      return false;
    }
    const hasProPlus = store.getters.getSelectedPlans.some(plan => planTypes.ZONE_PRO_PLUS === plan.type);
    return additionalConfigType.configType !== AdditionalConfigTypeEnums.NONE && hasProPlus;
  },
  data() {
    return {
      logo,
    };
  },

  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters({
      getSelectedPlans: 'getSelectedPlans',
      getUserCurrentSubscriptions: 'getUserCurrentSubscriptions',
    }),
    currentBillingCycle() {
      return BILLING_CYCLE.ANNUAL;
    },
    defaultPlan() {
      return null
    },
  },
  methods: {
    addOn() {
      // addPlanFromEnterKey For A11Y requirement
      // target is BUTTON comes from keyboard enter, will auto focaus on the first option in config card
      // target is SPAN comes from click
      document.addPlanFromEnterKey = true;
      this.$emit('add', this.$options?.key);
      this.$tracking.addOnBuyInteraction(this.title, `${this.title?.toLowerCase()} - add`);
    },
  }
};
</script>
